/* eslint-disable no-console -- opt-in debug logging gated by VITE_LOG_PROTOBUF_CHECKPOINT */
import { isProtobufCheckpointLoggingEnabled } from '@/config/config'
import type { SpreadCheckpoint } from '@/api/types/spread-checkpoint'

/** Set `VITE_LOG_PROTOBUF_CHECKPOINT=true` (e.g. in `.env.local`) and reload to enable logs. */
export function logProtobufCheckpointDebug(spreadId: string, checkpoint: SpreadCheckpoint): void {
  if (!isProtobufCheckpointLoggingEnabled()) return

  console.group(`[protobuf-checkpoint] spread ${spreadId} @ ${checkpoint.decodedAt}`)
  console.log(
    `elements: ${checkpoint.elements.length}, elementReferences: ${checkpoint.elementReferences?.length ?? 0}`
  )
  console.log('SpreadCheckpoint:', checkpoint)
  console.groupEnd()
}
